import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Environment, EnvironmentService } from '@galaxy/core';
import { getEmailQueuesStatus$, setEmailQueuesStatus$ } from '@vendasta/protos/email/v1/email-service';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-email-admin',
  templateUrl: 'email-admin.component.html',
  styleUrls: ['email-admin.component.scss'],
  standalone: false,
})
export class EmailAdminComponent implements OnInit {
  public env: string;

  queueStatus$ = getEmailQueuesStatus$({}).pipe(
    map((r) => r.running),
    startWith(null),
  );

  setStatus(a): void {
    setEmailQueuesStatus$({ running: a.checked }).subscribe();
  }

  constructor(
    public dialog: MatDialog,
    public envService: EnvironmentService,
  ) {}

  ngOnInit(): void {
    if (this.envService.getEnvironment() === Environment.PROD) {
      this.env = 'prod';
    } else {
      this.env = 'demo';
    }
  }
}
